import React, { useEffect, useState } from 'react'
import {
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    IconButton,
    Typography,
} from '@mui/material'
import { Close } from '@mui/icons-material'
import { api } from '../../../../services/Main/Api'
import SimpleTypography from '../../../../components/Shared/SimpleTypography'
import StatusInvoice from '../../../../components/Invoice/StatusInvoice'

const ChargeDetailDialog = ({ open, chargeId, onClose }) => {
    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (!open || !chargeId) return
        setLoading(true)
        setData(null)
        api.get(`/charge/${chargeId}`)
            .then(res => setData(res.data))
            .catch(err => console.error(err))
            .finally(() => setLoading(false))
    }, [open, chargeId])

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
            scroll="paper"
        >
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6" color="primary.main">
                    Detalhes da Cobrança
                </Typography>
                <IconButton onClick={onClose} size="small">
                    <Close />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                {loading ? (
                    <Box display="flex" justifyContent="center" py={4}>
                        <CircularProgress />
                    </Box>
                ) : data ? (
                    <Box>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                            <StatusInvoice invoice={data} />
                        </Box>

                        <Divider sx={{ mb: 2 }} />

                        <Box sx={{ px: 1 }}>
                            <SimpleTypography
                                label={'Imóvel'}
                                state={data}
                                type={'unit'}
                                keyName={'unit'}
                                isLoading={loading}
                                labelStyles={{ fontWeight: 'bold', fontSize: '16px' }}
                                styles={{ fontSize: '16px' }}
                            />
                            <SimpleTypography
                                label={'Vencimento'}
                                type={'date'}
                                state={data}
                                isLoading={loading}
                                keyName={'due_date'}
                                labelStyles={{ fontWeight: 'bold', fontSize: '16px' }}
                                styles={{ fontSize: '16px' }}
                            />
                            <SimpleTypography
                                label={'Total'}
                                type={'money'}
                                state={data}
                                isLoading={loading}
                                keyName={'total'}
                                labelStyles={{ fontWeight: 'bold', fontSize: '16px' }}
                                styles={{ fontSize: '16px' }}
                            />
                            {data?.description && (
                                <SimpleTypography
                                    label={'Descrição'}
                                    directValue={data.description}
                                    isLoading={loading}
                                    labelStyles={{ fontWeight: 'bold', fontSize: '16px' }}
                                    styles={{ fontSize: '16px' }}
                                />
                            )}
                        </Box>
                    </Box>
                ) : null}
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>Fechar</Button>
            </DialogActions>
        </Dialog>
    )
}

export default ChargeDetailDialog
